<div class="pagination-container">
  <button class="pagination-button" (click)="showPageClick(currentPageIndex -1)"
    *ngIf="currentPageIndex > 0">{{"pagination-previous" | translate}}</button>
  <button class="pagination-button" (click)="showPageClick(currentPageIndex + 1)"
  *ngIf="showNext()">{{"pagination-next" | translate}}</button>
</div>
